/* RK High Jewellery - CINEMATIC HORIZONTAL PAN (Iconic Necklaces & Earrings).
   Mobile / reduced-motion: pure-CSS scroll-snap SWIPE CAROUSEL (with JS dot tracking).
   Desktop + motion: JS adds .rkpan--pan (gallery pins) and drives the track's translateX from
   scroll progress through the gallery's pinned travel - a continuous, GPU-composited horizontal
   pan, exactly synced to the pin for any number of pieces. JS also runs the shared hero zoom-out
   scrub and keeps --rk-header-h synced. Skipped/falls back to the carousel under reduced motion. */
(function () {
  function headerEl() {
    return (
      document.querySelector('.header-wrapper') ||
      document.querySelector('.section-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('.header')
    );
  }
  var lastHeaderH = 110;
  function setHeaderVar() {
    var h = headerEl();
    var bottom = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 110;
    if (bottom !== lastHeaderH) {
      lastHeaderH = bottom;
      document.documentElement.style.setProperty('--rk-header-h', bottom + 'px');
    }
  }
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }
  function easeOut(p) { var inv = 1 - p; return 1 - inv * inv; }

  function initHero(root) {
    if (reduceMotion()) return;
    var hero = root.querySelector('[data-rkpan-hero]');
    var heroPin = root.querySelector('[data-rkpan-hero-pin]');
    var heroTitle = root.querySelector('[data-rkpan-hero-title]');
    var heroLines = Array.prototype.slice.call(root.querySelectorAll('[data-rkpan-line]'));
    if (!hero || !heroPin) return;
    root.classList.add('rkpan--motion');
    var scrub = 1;
    function measure() { scrub = Math.max(1, hero.offsetHeight - heroPin.offsetHeight); }
    var ticking = false;
    function apply() {
      ticking = false;
      if (!heroTitle) return;
      var e = easeOut(clamp01(Math.max(0, -hero.getBoundingClientRect().top) / scrub));
      heroTitle.style.transform = 'scale(' + (1 - 0.6 * e).toFixed(4) + ')';
      for (var i = 0; i < heroLines.length; i++) heroLines[i].style.transform = 'scaleY(' + (1 + 0.2 * e).toFixed(4) + ')';
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(apply); } }
    measure(); apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    window.addEventListener('load', function () { measure(); onScroll(); });
  }

  function initPan(root) {
    var gallery = root.querySelector('[data-rkpan-gallery]');
    if (!gallery) return;
    var pin = gallery.querySelector('.rkpan__pin');
    var track = root.querySelector('[data-rkpan-track]');
    var overlays = Array.prototype.slice.call(root.querySelectorAll('.rkpan__overlay'));
    if (!pin || !track) return;
    var rtl = (document.documentElement.getAttribute('dir') || document.dir) === 'rtl';
    var dirSign = rtl ? 1 : -1;     /* track pans toward inline-end */
    var enterSign = rtl ? -1 : 1;   /* text waits offset toward the RIGHT (inline-end), glides left into place */
    var PARALLAX = 90;              /* px - horizontal text entrance offset */
    var MARGIN = 0.09;              /* hysteresis deadband around each band boundary (no flicker) */
    var n = overlays.length;
    var active = false, dist = 1, current = -1;

    function panMode() { return window.innerWidth >= 750 && !reduceMotion(); }
    function measure() { dist = Math.max(1, gallery.offsetHeight - pin.offsetHeight); }

    /* Place every piece's text for a given active index. The active piece's text rests settled in
       place; every other piece's text waits HIDDEN, offset toward the inline-end (right in LTR),
       ready to parallax in when its image arrives. The CSS transitions do the gliding - so this is a
       smooth, TIMED entrance, never a raw scroll-scrub. */
    function placeOverlays(idx) {
      for (var j = 0; j < overlays.length; j++) {
        var settled = j === idx;
        overlays[j].style.opacity = settled ? '1' : '0';
        overlays[j].style.transform = 'translateX(' + (settled ? 0 : enterSign * PARALLAX).toFixed(2) + 'px)';
      }
    }

    /* Glide to a piece: a TIMED eased slide of the image track + the parallax-in of that piece's
       text (CSS owns both tweens). Because a full dwell band sits between boundaries, this only ever
       fires once the PREVIOUS piece's text has settled and been read. */
    function goTo(idx) {
      if (idx === current) return;
      current = idx;
      track.style.transform = 'translateX(' + (dirSign * idx * window.innerWidth).toFixed(2) + 'px)';
      placeOverlays(idx);
    }

    /* Reposition instantly (initial placement / resize) with the CSS transitions briefly suppressed,
       so setup never animates a long glide from a stale position. */
    function snapTo(idx) {
      var saved = overlays.map(function (o) { return o.style.transition; });
      track.style.transition = 'none';
      overlays.forEach(function (o) { o.style.transition = 'none'; });
      current = idx;
      track.style.transform = 'translateX(' + (dirSign * idx * window.innerWidth).toFixed(2) + 'px)';
      placeOverlays(idx);
      void track.offsetWidth; /* force reflow so the no-transition state commits */
      track.style.transition = '';
      overlays.forEach(function (o, k) { o.style.transition = saved[k]; });
    }

    function bandFor(p) {
      var pos = p * n;                 /* 0..n - which dwell band the scroll sits in */
      var idx = current < 0 ? Math.floor(pos) : current;
      if (idx < 0) idx = 0; if (idx > n - 1) idx = n - 1;
      /* hysteresis: only cross a boundary once scroll has passed it by MARGIN (no edge flicker) */
      while (idx < n - 1 && pos >= (idx + 1) + MARGIN) idx++;
      while (idx > 0 && pos < idx - MARGIN) idx--;
      return idx;
    }

    var ticking = false;
    function apply() {
      ticking = false;
      if (!active || n === 0) return;
      var p = clamp01((lastHeaderH - gallery.getBoundingClientRect().top) / dist);
      goTo(bandFor(p));
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(apply); } }
    function clearOverlays() { for (var c = 0; c < overlays.length; c++) { overlays[c].style.transform = ''; overlays[c].style.opacity = ''; } }

    function activate() {
      if (!active) { active = true; root.classList.add('rkpan--pan'); }
      measure();
      var p = clamp01((lastHeaderH - gallery.getBoundingClientRect().top) / dist);
      var pos = p * n;
      var idx = Math.floor(pos); if (idx < 0) idx = 0; if (idx > n - 1) idx = n - 1;
      snapTo(idx);
    }
    function deactivate() {
      if (active) {
        active = false; current = -1;
        root.classList.remove('rkpan--pan');
        track.style.transition = 'none';
        track.style.transform = '';
        clearOverlays();
        void track.offsetWidth;
        track.style.transition = '';
      }
    }
    function evaluate() { if (panMode()) activate(); else deactivate(); }

    evaluate();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { evaluate(); }, { passive: true });
    window.addEventListener('load', function () { evaluate(); });
  }

  function initDots(root) {
    var track = root.querySelector('[data-rkpan-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rkpan-dot]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rkpan-slide]'));
    if (!track || dots.length < 2 || slides.length !== dots.length) return;
    function setActive(i) { for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i); }
    setActive(0);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { var idx = slides.indexOf(en.target); if (idx >= 0) setActive(idx); }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    dots.forEach(function (dot, k) {
      dot.addEventListener('click', function () {
        if (slides[k]) slides[k].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.rkpanReady === '1') return;
    root.dataset.rkpanReady = '1';
    initHero(root);
    initPan(root);
    initDots(root);
  }

  function init() {
    setHeaderVar();
    window.addEventListener('resize', setHeaderVar, { passive: true });
    window.addEventListener('scroll', setHeaderVar, { passive: true });
    window.addEventListener('load', setHeaderVar);
    document.addEventListener('shopify:section:load', setHeaderVar);
    Array.prototype.slice.call(document.querySelectorAll('[data-rkpan]')).forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-rkpan]') : null;
    if (root) { root.dataset.rkpanReady = ''; initRoot(root); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
